import type { Config } from "@kaltura/mediaspace-shared-data-kms-config/Config";
import { defaultContext } from "@kaltura/mediaspace-shared-data-kms-config/ConfigContext";

export const rootGalleryCategoryId = "13744992";
export const rootGalleryCategoryFullId = "13744972>13744982>" + rootGalleryCategoryId;

export const mockContext: Config = {
    ...defaultContext,
    categories: {
        rootGalleryCategoryId,
    },
};

export const mockNvqContext: Config = {
    ...mockContext,
    application: {
        ...mockContext.application,
        serviceUrl: "https://api.nvq2.ovp.kaltura.com",
    },
};

export const mockKafContext: Config = {
    ...mockContext,
    application: {
        ...mockContext.application,
        isKAF: true,
    },
};
